import { useEffect, useMemo } from 'react';
import 'stream-chat-react';
import '@planningcenter/datetime-fmt';
import '../../../../_virtual/moment.js';
import { useChat } from '../../../hooks/use_chat.js';
import '../../../chat_api_context.js';
import '@planningcenter/url';
import { SERVICES_INITIAL_VALUES } from '../../../hooks/use_chat_filter.js';
import '@planningcenter/jolt-client';
import 'stream-chat';

const useServicesChatFilter = (isActive) => {
    const { filterValues, setFilterValues } = useChat();
    const { Services } = filterValues;
    useEffect(() => {
        setFilterValues({
            appName: "Services",
            values: isActive
                ? (prev) => prev
                : SERVICES_INITIAL_VALUES,
        });
    }, [isActive]);
    const isPlansActive = useMemo(() => {
        const [first, ...rest] = Services.teams;
        return (Boolean(first) &&
            rest.every(({ service_type_id }) => service_type_id === first.service_type_id));
    }, [Services.teams]);
    useEffect(() => {
        if (isPlansActive)
            return;
        setFilterValues({
            appName: "Services",
            values: (prev) => ({ ...prev, plan_id: null }),
        });
    }, [isPlansActive]);
    const isFiltering = Services.teams.length > 0;
    return { filterValues: Services, isFiltering, isPlansActive, setFilterValues };
};

export { useServicesChatFilter };
//# sourceMappingURL=use_services_chat_filter.js.map
